import React from 'react';
import styled from 'styled-components';
import { Label } from 'styles/Styles.styled';
import TooltipHelpIcon from 'components/v2/icons/TooltipHelpIcon';
import Tooltip from 'components/controls/Tooltip';

export const OldUIReadonlyTextInput: React.FC<{
  label: string;
  tooltip?: string;
  value: string;
  className?: string;
}> = ({ label, tooltip, value, className }) => {
  return (
    <Wrapper className={className}>
      <StyledLabel>
        {label}
        {tooltip && <TooltipHelpIcon content={tooltip} position="bottom" />}
      </StyledLabel>
      <TextBox>
        {value}
        <Tooltip position="titleEllipsed">{value}</Tooltip>
      </TextBox>
    </Wrapper>
  );
};
export default OldUIReadonlyTextInput;

const Wrapper = styled.div`
  font-family: ${(props) => props.theme.fontFamilies.body};
  display: grid;
  gap: 8px;
`;

const StyledLabel = styled(Label)`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const TextBox = styled.div`
  padding: 15px 12px;
  border: solid 1px gray;
  background-color: ${(props) => props.theme.colors.elementInputDisabled};
  font-size: 14px;
  color: ${(props) => props.theme.colors.primaryBlack70};
  min-height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
